import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './Pagination.module.scss';
import { back, next } from '@assets/index';
const Pagination = (props) => {
    const { pageNumbers, totalPages, currentPage, setCurrentPage } = props;
    const nextHandler = () => {
        if (currentPage < totalPages) {
            const nextPage = currentPage + 1;
            setCurrentPage(nextPage);
        }
    };
    const backHandler = () => {
        if (currentPage > 1) {
            const prevPage = currentPage - 1;
            setCurrentPage(prevPage);
        }
    };
    return (_jsxs("div", Object.assign({ className: styles.pagination, tabIndex: 0, "data-testid": "pagination" }, { children: [_jsx("div", Object.assign({ className: styles.pagination__back }, { children: _jsx("button", Object.assign({ onClick: backHandler, disabled: currentPage === 1 }, { children: _jsx("img", { src: back, alt: "back" }) })) })), _jsx("div", Object.assign({ className: styles.pagination__pages }, { children: pageNumbers.map((num) => (_jsx("div", Object.assign({ className: `${styles.pagination__pageNumber} ${num === currentPage ? styles.active : ''}`, onClick: () => setCurrentPage(num) }, { children: _jsx("p", { children: num }) }), num))) })), _jsx("div", Object.assign({ className: styles.pagination__next }, { children: _jsx("button", Object.assign({ onClick: nextHandler, disabled: currentPage >= totalPages }, { children: _jsx("img", { src: next, alt: "next" }) })) }))] })));
};
export default Pagination;
